// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__219Zo","modalForm":"UpgradeEpcsModal_modalForm__nQWxh","modalFooter":"UpgradeEpcsModal_modalFooter__1ugKb"};